/**
 * What a PER_ORDER_CREDIT plan sends for the two columns it does not use.
 *
 * `amount` and `periodDays` describe a recurring subscription: a price per
 * period, and how long a period lasts. A per-order plan has neither — it has
 * one number, the deduction per order — so asking an admin for them is asking
 * for an answer that cannot be right. Both columns are `NOT NULL` in the DB
 * though, so the fields are hidden and these safe defaults go over the wire
 * instead. Nothing reads them for this plan type: billing-period charges are
 * never generated for a per-order store, and `isPerOrderAssignment` short-
 * circuits every overdue/next-payment derivation before either is consulted.
 */
export const PER_ORDER_PLAN_AMOUNT = 0;

/** Matches the `period_days` convention elsewhere; unused for this plan type. */
export const PER_ORDER_PLAN_PERIOD_DAYS = 30;
